import { showAlert } from 'in-meeting-experience-ui-components/components/common/GeneralAlert';
import { useCallback, useEffect, useRef } from 'react';
import { routes } from '../constants/routes';
import { openPopup } from '../utils/popupUtils';
import { getAppDomain } from '../utils/urls';
const useOauthPopup = () => {
  const checkWindowInterval = useRef(undefined);
  const authCancelled = useCallback(() => {
    clearInterval(checkWindowInterval.current);
    showAlert({
      title: 'reconnect.oauthFailed.title',
      message: 'reconnect.oauthFailed.description',
      type: 'warning',
      timeout: 10000,
      id: 'oauth-failed'
    });
  }, []);
  const authCallback = useCallback(() => {
    clearInterval(checkWindowInterval.current);
    window.location.href = `${getAppDomain()}${routes.base}`;
  }, []);
  const openUrlFunction = useCallback(url => {
    const popup = openPopup(url);
    checkWindowInterval.current = setInterval(() => {
      if (!popup || popup.closed) {
        authCancelled();
        clearInterval(checkWindowInterval.current);
      }
    }, 500);
  }, [authCancelled]);
  useEffect(() => {
    // @ts-expect-error property does not exist on type 'Window & typeof globalThis'
    window.authCancelled = authCancelled;
    // @ts-expect-error property does not exist on type 'Window & typeof globalThis'
    window.authCallback = authCallback;
  }, [authCallback, authCancelled]);
  return openUrlFunction;
};
export default useOauthPopup;